module.exports = __webpack_public_path__ + "static/img/ent-97.452c039.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-97.jpg
// module id = ofcA
// module chunks = 52